/* Native transport bridge only. No managed provider, persistence permission or executor activation. */
(function(root){
  'use strict';
  if(root.NikuyaCartNativeFence||!root.NikuyaCartMutationFence||!root.NikuyaCartRuntimeIdentity)return;
  const identity=root.NikuyaCartRuntimeIdentity.create({fetch:(...args)=>root.fetch(...args),getOrigin:()=>root.location.origin,getRoutesRoot:()=>root.Shopify?.routes?.root,crypto:root.crypto});
  root.NikuyaCartNativeFence=root.NikuyaCartMutationFence.create({identity,locks:root.navigator?.locks});
})(globalThis);
